// extracted by css-extract-rspack-plugin
export default {"Box":"base-project-view-filter-input-module__Box__QPi9n"};